<template>
  <div class="create-new-sku">
    <div class="breadcrumb" style="background: #fff">创建SKU组</div>
    <div class="third-title">SKU组属性</div>
    <div class="order-detail-basic" style="padding-top: 0;">
      <el-form :model="attrList" :rules="rules" label-width="150px" ref="formRef">
        <el-form-item v-for="(val, key, index) in attrList" :key="key" :label="key + '：'">
          <div>
            <el-button type="primary" @click="choiceAttr(key, index)" round>选择</el-button>
            <div style="margin-top:10px;padding-left:20px;">
              <span class="asdasd" v-for="(item, index) in val" :key="item.id">{{ item.propVal }}<i class="el-icon-close x" @click="deleteAttr(val, index, key)"></i></span>
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button round type="primary" style="margin-left:-50px" @click="createSku">生成SKU组</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="third-title">SKU组</div>
    <div class="order-detail-basic">
      <div class="data-list">
        <el-table :data="skuList" ref="table" border :row-class-name="RowClassName" @row-click="rowClick" @selection-change="handleChange" style="width: 90%">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="SKU组名称" prop="skuGroupName" min-width="250px">
            <template v-slot="scope">
              <el-input v-model="scope.row.skuGroupName"></el-input>
            </template>
          </el-table-column>
          <el-table-column v-for="(val, key) in attrList" :key="key" :label="key" min-width="100px">
            <template v-slot="scope"> {{ scope.row.dictList[key].name }} </template>
          </el-table-column>
          <el-table-column label="SKU组图片" min-width="100px">
            <template v-slot="scope">
              <div class="imgbox">
                <p class="color-blue" @click="uploadImg(scope.row.index)" v-if="scope.row.skuGroupImage === ''">上传图片</p>
                <div v-else>
                  <div class="qqqqqq">
                    <img :src="scope.row.skuGroupImage" alt="">
                  </div>
                  <span @click="deleteImg(scope.row.index)" class="color-blue">删除图片</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="通货编码" v-if="$route.query.spuProperty === 'NORMAL'" prop="sampleBarCode" min-width="150px">
            <template v-slot="scope">
              <el-input v-model="scope.row.sampleBarCode"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="价格" v-if="$route.query.spuProperty === 'NORMAL'" prop="price" min-width="150px">
            <template v-slot="scope">
              <el-input v-model="scope.row.price"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="积分价格" v-if="$route.query.spuProperty === 'NORMAL' && $route.query.showPoint == 'true'" prop="basePagePoints" min-width="150px">
            <template v-slot="scope">
              <el-input v-model="scope.row.basePagePoints"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="在线支付价格" v-if="$route.query.spuProperty === 'NORMAL'" prop="onlineSalePrice" min-width="150px">
            <template v-slot="scope">
              <el-input v-model="scope.row.onlineSalePrice"></el-input>
            </template>
          </el-table-column>
          <!-- 新加的 -->
          <el-table-column label="初创平台价格" v-if="$route.query.spuProperty === 'NORMAL' && $route.query.startupsSpu && $route.query.showPoint != 'true'" prop="startupsBasePagePrice" min-width="150px">
            <template v-slot="scope">
              <el-input v-model="scope.row.startupsBasePagePrice"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="推荐终端价格" v-if="$route.query.spuProperty === 'NORMAL'" prop="salePrice" min-width="150px">
            <template v-slot="scope">
              <el-input v-model="scope.row.salePrice"></el-input>
            </template>
          </el-table-column>
        </el-table>
        <el-upload class="avatar-uploader upload_warp_left" id="upload-img" style="display:none" action="#" :http-request="fileSize"></el-upload>
      </div>
    </div>
    <div class="edit-button">
      <el-button round type="primary" @click="checkSingle()">{{ $route.query.spuProperty === 'NORMAL' ? '完成' : '下一步' }}</el-button>
    </div>
    <CombinedDialog ref="dialogRef" @addAttr="getNewAttr" @select-attr="addAttrTags"></CombinedDialog>
    <!-- 选择属性 -->
    <el-dialog :close-on-click-modal="false" title="选择属性值" :visible.sync="dialogVisible" width="30%">
      <p>属性名：{{ selectAttr }}</p>
      <el-table ref="multipleTable" :data="tableData" border @selection-change="handleSelectionChange" height="450px" tooltip-effect="dark" style="width: 100%">
        <el-table-column class="selection" type="selection" width="55"></el-table-column>
        <el-table-column label="属性值">
          <template slot-scope="scope">{{ scope.row.propVal }}</template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 已生成后删除属性提示 -->
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="delAttrDialog" width="30%">
      <span>是否生成sku组？</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="delAttrDialog = false">取 消</el-button>
        <el-button type="primary" @click="filterSkuList" v-preventReClick>确 定</el-button>
      </span>
    </el-dialog>
    <!-- 下一步提示 -->
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="nextDialog" width="30%">
      <span>sku组信息是否填写无误？确定后将无法返回</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="nextDialog = false">取 消</el-button>
        <el-button type="primary" @click="confirm()" v-preventReClick>确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import CombinedDialog from '@/components/Dialog/CombinedDialog/index'
import { dictQueryByPid, dictGet, skuGroupAdd, skuGroupAddCurrency } from '@/api/pms'
import { storeTypeGetStoreTypeList } from '@/api/crm'
import uploadWebImg, { getAwsSdk } from '@/utils/uploadWebImg'
export default {
  name: 'CreateNewSKu',
  components: {
    CombinedDialog
  },
  data () {
    return {
      nextDialog: false,
      delAttrDialog: false,
      dickKey: [],
      attrKeyList: [],
      uploadIndex: '',
      multipleSelection: [],
      tableData: [],
      selectAttr: '',
      addAttrType: {},
      dialogVisible: false,
      skuTitle: '统一添加',
      sampleTheme: [],
      attrList: {},
      rules: {},
      // sku组属性
      skuList: [],
      // 选中的sku组
      selectedSKUList: [],
      platformType: [],
      tableColumns: [],
      themeList: [],
      themeName: '添加样品',
      dictList: [],
      delAttrInfo: {}
    }
  },
  created () {
    if (this.$checkAwsSdk('product')) this.$store.dispatch('awsSdk/getAwsSdk', 'product')
    // this.getPlatformType()
    this.getAttrList()
  },
  beforeRouteEnter (to, from, next) {
    if (from.path !== '/createPro') {
      next('/productlist')
    } else {
      next()
    }
  },
  methods: {
    checkSingle () {
      if (this.$route.query.isSingleSkuGroup === 'true' && (this.selectedSKUList.length > 1)) {
        this.$message.error('单SKU组产品只能选择一个SKU组')
        return
      }
      this.nextDialog = true
    },
    rowClick (val) {
      // this.$refs.table.toggleRowSelection(val)
    },
    check (val) {
    },
    // 过滤出skuList
    filterSkuList () {
      this.skuList = this.skuList.filter(item => {
        return item.dictList[this.delAttrInfo.propKey].id !== this.delAttrInfo.id
      })
      this.$forceUpdate()
      this.delAttrDialog = false
    },
    // 删除图片
    deleteImg (index) {
      this.skuList[index].skuGroupImage = ''
    },
    fileSize (data) {
      let file = data.file
      if (file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/webp') {
        this.$message.error('请上传jpeg/png格式的图片')
        return
      }
      if (file.size > 1024 * 1024 * 10) {
        this.$message.error('图片大小不能超过10M')
        return
      }

      var _this = this
      var reader = new FileReader()
      reader.onload = function (e) {
        var data = e.target.result
        // 加载图片获取图片真实宽度和高度
        var image = new Image()
        image.onload = function () {
          var width = image.width
          var height = image.height
          // 婚纱或者积分产品不验证 尺寸 
          if (_this.$route.query.categoryId == 10 || _this.$route.query.categoryId == 13) {
            _this.httpRequest(file)
          } else {
            if (width === height) {
              _this.httpRequest(file)
            } else {
              _this.$message.error('图片长宽不相同')
            }
          }
        }
        image.src = data
      }
      reader.readAsDataURL(file)
    },
    // 上传图片
    httpRequest (file) {
      uploadWebImg(file, this.$store.state.awsSdk.product.s3, [], () => { }, 150, 150).then(res => {
        this.skuList[this.uploadIndex].skuGroupImage = res
      })
    },
    // 点击上传
    uploadImg (index) {
      this.uploadIndex = index
      document.querySelector('.el-upload__input').click()
    },
    // 删除选择属性
    deleteAttr (val, index, key) {
      this.delAttrInfo = val[index]
      val.splice(index, 1)
      if (this.skuList.length !== 0) {
        this.delAttrDialog = true
      }
      this.$forceUpdate()
    },
    // 确定选择
    onSubmit () {
      let list = []
      this.multipleSelection.forEach(item => {
        list.push(item)
      })
      this.attrList[this.selectAttr] = list
      this.dialogVisible = false
    },
    // 选择属性
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    // 获取属性
    getAttrList () {
      let list = typeof this.$route.query.list === 'string' ? [this.$route.query.list] : this.$route.query.list
      list.forEach(item => {
        // 名称
        dictGet(item).then(res => {
          if (res.data.success) {
            this.dickKey.push({ id: res.data.data.id, key: res.data.data.propKey })
            this.attrList[res.data.data.propKey] = []
            this.attrKeyList.push(res.data.data)
            this.$forceUpdate()
          }
        })
      })
    },
    // 选择attr
    choiceAttr (key, index) {
      this.selectAttr = key
      // 查询下级
      this.dickKey.forEach(item => {
        if (item.key === key) {
          dictQueryByPid(item.id).then(res => {
            if (res.data.success) {
              this.tableData = res.data.data
              this.dialogVisible = true
            }
          })
        }
      })
    },
    // 11111111111111111111111111111111111111111111111111111111111111111111111111
    RowClassName ({ row, rowIndex }) {
      row.index = rowIndex
    },
    // // 获取平台类型
    // getPlatformType () {
    //   // storeTypeGetStoreTypeList().then(res => {
    //   // })
    //   storeTypeGetStoreTypeList().then(res => {
    //     // this.platformType = res
    //   })
    // },
    // 添加tags标签
    addAttrTags (val) {
      let newList = val.list
      if (val.isMallShow === 0) {
        let newShowAttr = this.attrList.hideAttr[val.index]
        newShowAttr.tags = newList
        this.$set(this.attrList.hideAttr, val.index, newShowAttr)
      }
      if (val.isMallShow === 1) {
        let newShowAttr = this.attrList.showAttr[val.index]
        newShowAttr.tags = newList
        this.$set(this.attrList.showAttr, val.index, newShowAttr)
      }
    },
    // 添加属性值
    getNewAttr (val) {
      // this.get()
    },
    // 关闭tag标签
    handleClose (index, index2) {
      this.attrList.showAttr.push()
      let a = this.attrList.showAttr
      a[index].tags.splice(index2, 1)
    },
    handleClose2 (index, index2) {
      this.attrList.hideAttr.push()
      let a = this.attrList.hideAttr
      a[index].tags.splice(index2, 1)
    },
    combine_arr (arr) {
      var sarr = [[]]
      for (var i = 0; i < arr.length; i++) {
        var tarr = []
        for (var j = 0; j < sarr.length; j++) {
          for (var k = 0; k < arr[i].length; k++) {
            tarr.push(sarr[j].concat(arr[i][k] + ',').toString())
          }
        }
        sarr = tarr
      }
      return sarr
    },
    // 组合
    getCombination (attrObj) {
      let result = []
      for (let attrName in attrObj) {
        if (result.length === 0) {
          attrObj[attrName].forEach(item => {
            let obj1 = {}
            obj1[attrName] = { name: item.propVal, id: item.id }
            result.push(obj1)
          })
        } else {
          const emptyArray = []
          result.forEach(item => {
            attrObj[attrName].forEach(val => {
              let obj2 = { ...item }
              obj2[attrName] = { name: val.propVal, id: val.id }
              emptyArray.push(obj2)
            })
          })
          result = JSON.parse(JSON.stringify(emptyArray))
        }
      }
      return result
    },
    // 生成SKU组
    createSku () {
      let newList = []
      for (let key in this.attrList) {
        if (this.attrList[key].length === 0) {
          this.$message.error('有属性未选值')
          return
        }
      }
      this.getCombination(this.attrList).forEach(item => {
        let name = []
        for (let val in item) {
          name.push(item[val].name)
        }
        newList.push({
          dictList: { ...item },
          skuGroupName: this.$route.query.spuName + '-' + name.join('-'),
          skuGroupImage: '',
          price: '',
          sampleBarCode: '',
          salePrice: '',
          onlineSalePrice: '',
          startupsBasePagePrice: ''
        })
      })
      this.skuList = newList
    },
    upload (e, index) {
      var file = e.target.files
      let _this = this
      var reader = new FileReader()
      reader.readAsDataURL(file[0])
      reader.onload = function () {
        _this.skuList[index].imgInfo = {
          src: reader.result,
          operation: '删除图片'
        }
      }
    },
    changeImg (operation, index) {
      if (operation === '删除图片') {
        // let showPicture = document.getElementsByClassName('show_img')[index]
        // showPicture.innerHTML = ''
        this.skuList[index].imgInfo.operation = '上传图片'
        // this.skuList[0].imgInfo.isShow = false
        this.skuList[index].imgInfo.src = ''
      }
    },
    handleChange (val) {
      this.selectedSKUList = val
    },
    confirm () {
      this.nextDialog = false
      if (this.selectedSKUList.length === 0) {
        this.$refs.dialogRef.show('primary', '确定提示', '没有勾选的SKU组信息<br/>请选择SKU组后创建')
      } else {
        let skuGroups = []
        let imgLock = false
        let nameLock = false
        this.selectedSKUList.forEach(item => {
          if (item.skuGroupName === '') {
            nameLock = true
          }
          if (item.skuGroupImage === '') {
            imgLock = true
          }
          let obj = {
            dictIdSet: '',
            dictSet: '',
            skuGroupImage: item.skuGroupImage,
            skuGroupName: item.skuGroupName,
            isTimeLimit: false,
            stockCount: 5000
          }
          if (this.$route.query.spuProperty === 'NORMAL') {
            obj.skuName = item.skuGroupName
            obj.price = item.price
            obj.sampleBarCode = item.sampleBarCode
            obj.salePrice = item.salePrice
            obj.onlineSalePrice = item.onlineSalePrice
            obj.startupsBasePagePrice = item.startupsBasePagePrice
            obj.basePagePoints = item.basePagePoints
          }
          for (let key in item.dictList) {
            this.attrKeyList.forEach(attr => {
              if (key === attr.propKey) {
                obj.dictIdSet += attr.id + ':' + item.dictList[key].id + ';'
              }
            })
            obj.dictSet += key + ':' + item.dictList[key].name + ';'
          }
          skuGroups.push(obj)
        })
        if (imgLock) {
          this.$message.error('有未上传的sku组图片，请上传后重试')
          return
        }
        if (nameLock) {
          this.$message.error('未输入SKU组名称')
          return
        }
        if (this.$route.query.spuProperty === 'NORMAL') {
          let priceLock = false
          let sampleBarCodeLock = false
          skuGroups.forEach(item => {
            if (
              !this.$reg.price.reg.test(item.price) ||
              !this.$reg.price.reg.test(item.salePrice) ||
              !this.$reg.price.reg.test(item.onlineSalePrice) ||
              (!this.$reg.price.reg.test(item.startupsBasePagePrice) && this.$route.query.showPoint != 'true') ||
              (!this.$reg.price.reg.test(item.basePagePoints) && this.$route.query.showPoint == 'true')
            ) {
              priceLock = true
            }
            if (!item.sampleBarCode) {
              sampleBarCodeLock = true
            }
          })
          if (priceLock) {
            this.$message.error('价格' + this.$reg.price.message)
            return
          } else if (sampleBarCodeLock) {
            this.$message.error('请输入通货编码')
            return
          }
          skuGroupAddCurrency({ spuId: this.$route.query.id, skuGroups }).then(res => {
            if (res.data.success) {
              this.$router.push('/productlist')
            }
          })
        } else {
          skuGroupAdd({ spuId: this.$route.query.id, skuGroups }).then(res => {
            if (res.data.success) {
              let data = JSON.stringify(res.data.data)
              // let startupsSpu = this.$route.query.startupsSpu
              let startupsSpu = false
              if (this.$route.query.categoryId == 10) {
                startupsSpu = true
              } else {
                startupsSpu = false
              }
              this.$router.push({
                path: '/createnewsku2',
                query: {
                  detail: data,
                  dict: JSON.stringify(this.dickKey),
                  hasWhitePage: this.$route.query.hasWhitePage,
                  isVip: this.$route.query.isVip,
                  isSingleSkuGroup: this.$route.query.isSingleSkuGroup,
                  isHavePromoCode: this.$route.query.isHavePromoCode,
                  startupsSpu: startupsSpu,
                  showPoint: this.$route.query.categoryId == 13
                }
              })
            }
          })
        }
      }

      // let newList = []
      // this.selectedSKUList.forEach((item, index) => {
      //   newList[index] = {}
      //   newList[index].dictIdSet = ''
      //   newList[index].skuGroupImage = 'https://ss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=3142877760,854034002&fm=11&gp=0.jpg'
      //   newList[index].skuGroupName = item.skuGroupName
      //   newList[index].dictSet = ''
      //   this.tableColumns.forEach((item2) => {
      //     dictQueryByPid(item2.id).then((res) => {
      //       if (res.data.success) {
      //         for (let j = 0; j < res.data.data.length; j++) {
      //           if (res.data.data[j].propVal === item[item2.propKey]) {
      //             newList[index].dictIdSet += item2.id + ':' + res.data.data[j].id + ';'
      //             newList[index].dictSet += res.data.data[j].propVal + ' '
      //           }
      //           continue
      //         }
      //       }
      //     })
      //   })
      // })
      // this.$refs.dialogRef.show('changeSalesman', '确定提示', 'SKU组创建确定<br>是否确定创建SKU组', this.selectedSKUList, {
      //   spuId: +this.$route.query.id,
      //   skuGroups: newList
      // }, this.dictList)
      // }
    },
    returnPage () {
      if (window.history.length <= 1) {
        this.$router.push({ path: ' /home' })
        return false
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>
<style scoped lang="less">
@import "./styles.less";

@deep: ~">>>";

.asdasd {
  margin-bottom: 5px;
  display: inline-block;
  box-sizing: border-box;
  padding: 0px 28px 0 10px;
  // width:80px;
  height: 30px;
  background: rgba(170, 170, 170, 1);
  color: #fff;
  position: relative;
  margin-right: 10px;

  .x {
    position: absolute;
    top: 8px;
    right: 5px;
  }
}

.imgbox {
  // width: 150px;
  height: 150px;

  p {
    height: 100%;
    text-align: center;
    line-height: 150px;
  }

  .qqqqqq {
    width: 100px;
    height: 100px;
    margin: 15px auto;

    img {
      max-width: 100%;
      max-height: 100%;
      display: block;
      margin: auto;
    }
  }

  span {
    display: block;
  }
}

@{deep} .el-table-column--selection .cell {
  padding-right: 10px;
}
</style>
